module.exports = __webpack_public_path__ + "img/not-found.923923f8.svg";